"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateOptionPnl = exports.calculateFuturePnl = exports.getPositionValuesForDomain = exports.getAllCcyPnlSum = exports.calculatePositionsPnl = exports.getPositionUsableValues = exports.calculateLinearFuturePoint = void 0;
/**
 * Place for putting logic for calculating everything connected to options and features.
 */
// import { TableAccount } from 'features/PortfoliosTable/tableSlice';
const calculationsChart_1 = require("../calculationsChart");
const breakevenPoints_1 = require("../calculationsChart/breakevenPoints");
const types_1 = require("../types");
const calculationUtils_1 = require("./calculationUtils");
const futurePnlCalculator_1 = require("./futurePnlCalculator");
const optionPnlCalculator_1 = require("./optionPnlCalculator");
const volatilitySmile_1 = require("./volatilitySmile");
__exportStar(require("./calculationUtils"), exports);
__exportStar(require("./greeks"), exports);
__exportStar(require("./margins"), exports);
var futurePnlCalculator_2 = require("./futurePnlCalculator");
Object.defineProperty(exports, "calculateLinearFuturePoint", { enumerable: true, get: function () { return futurePnlCalculator_2.calculateLinearFuturePoint; } });
// ----------------------------------------- //
// ---------------- PUBLIC ----------------- //
// ----------------------------------------- //
// TODO momentary duplication from pb-v3. Once we sync everywhere CorePosition and we remove newPosition it should be gone
/**
 * This function will return the correct one needed for calculation.
 * If we have updated something it will give us the updated value, otherwise the real.
 *
 * @param position
 * @returns
 */
const getPositionUsableValues = (position) => {
    const amount = position.updatedAmount
        ? position.updatedAmount
        : position.amount;
    const averagePrice = position.updatedAveragePrice
        ? position.updatedAveragePrice
        : position.averagePrice;
    return {
        amount,
        averagePrice,
    };
};
exports.getPositionUsableValues = getPositionUsableValues;
/**
 *
 * Calculates pnl for positions.
 *
 * @param domain
 * @param positions
 * @param tickers
 * @param currencyType
 * @param implVolType
 * @param currentTimestamp
 * @returns Two number[] representing the pnl without taking into consideration equity or offset.
 */
const calculatePositionsPnl = (domain, positions, tickers, currencyType, implVolType, calculationTimestamp, isOffsetActive, usdUsdcIndex) => {
    const expireSum = domain.map((x) => 0);
    const todaySum = domain.map((x) => 0);
    const corePositions = positions
        .filter((p) => (0, calculationUtils_1.getInstrumentType)(p.instrument) !== types_1.PositionType.VolatilityFuture)
        .map((p) => {
        const { amount, averagePrice } = (0, exports.getPositionUsableValues)(p);
        return {
            amount,
            // Not needed for these calculations
            amountCurrency: 0,
            averagePrice,
            checked: p.checked,
            instrument: p.instrument,
            uuid: p.uuid,
        };
    });
    for (const position of corePositions) {
        if (tickers[position.instrument] && position.amount !== 0) {
            const { expireLine, todayLine } = (0, exports.getPositionValuesForDomain)(domain, position, tickers, currencyType, implVolType, calculationTimestamp, isOffsetActive, new Date().getTime(), usdUsdcIndex);
            for (let i = 0; i < domain.length; i++) {
                expireSum[i] += expireLine[i];
                todaySum[i] += todayLine[i];
            }
        }
    }
    return {
        expireLine: expireSum,
        todayLine: todaySum,
    };
};
exports.calculatePositionsPnl = calculatePositionsPnl;
/**
 * In a case that we have only one currency selected it will return only that because positions
 * will be filtered.
 */
const getAllCcyPnlSum = (domains, positions, tickers, impliedVolatilityCalculationType, calculationTimestamp, currencyType, pageOperationCurrency, isOffsetActive, usdUsdcIndex, equityOffset) => {
    const todayLineSum = domains[pageOperationCurrency].map((x) => 0);
    const expireLineSum = domains[pageOperationCurrency].map((x) => 0);
    for (const currentCurrency of [types_1.Currency.BTC, types_1.Currency.ETH, types_1.Currency.USDC]) {
        let currentCcyPositions = [];
        if (currentCurrency === types_1.Currency.USDC) {
            currentCcyPositions = positions.filter((p) => (0, calculationUtils_1.isLinearPerpetual)(p.instrument));
        }
        else {
            currentCcyPositions = currentCcyPositions = positions.filter((p) => {
                const res = (0, calculationUtils_1.getBaseCurrencyFromInstrumentString)(p.instrument) ===
                    currentCurrency && !(0, calculationUtils_1.isLinearPerpetual)(p.instrument);
                return res;
            });
        }
        currentCcyPositions = currentCcyPositions.filter((p) => !p.instrument.includes("DVOL"));
        if (currentCcyPositions.length > 0) {
            const currentCcyPnl = (0, exports.calculatePositionsPnl)(domains[currentCurrency], currentCcyPositions, tickers, currencyType, impliedVolatilityCalculationType, calculationTimestamp, isOffsetActive, usdUsdcIndex);
            for (let i = 0; i < domains[currentCurrency].length; i++) {
                expireLineSum[i] += currentCcyPnl.expireLine[i];
                todayLineSum[i] += currentCcyPnl.todayLine[i];
            }
        }
    }
    const todayOffseted = (0, calculationsChart_1.sumTwoArrays)(todayLineSum, equityOffset);
    const expireOffseted = (0, calculationsChart_1.sumTwoArrays)(expireLineSum, equityOffset);
    let breakevenPoints = (0, breakevenPoints_1.calculateBreakevenPointsForALine)(domains[pageOperationCurrency], positions, tickers, currencyType, impliedVolatilityCalculationType, calculationTimestamp, isOffsetActive, usdUsdcIndex, todayOffseted);
    if (pageOperationCurrency === types_1.Currency.ALL ||
        pageOperationCurrency === types_1.Currency.USDC) {
        breakevenPoints = breakevenPoints.map((p) => p - 1);
    }
    return {
        expireLine: {
            values: expireOffseted,
        },
        todayLine: {
            values: todayOffseted,
        },
        breakevenPoints,
    };
};
exports.getAllCcyPnlSum = getAllCcyPnlSum;
// ----------------------------------------- //
// ---------------- PRIVATE ---------------- //
// ----------------------------------------- //
/**
 *  First we calculate interest and time to expiry for current ticker values and use them to
 *  calculate pnl for a position over a domain.
 *
 * @param domain
 * @param position
 * @param tickers
 * @param currencyType
 * @param implVolType
 * @param calculationTimestamp - Slider timestamp.
 * @param isOffsetActive
 * @param timestampWhenCalculating - Time when we are doing the calculation, usually is new Date().getTime(). This is important for calculating the implied rate
 * and time to expiry
 * @returns
 */
const getPositionValuesForDomain = (domain, position, tickers, currencyType, implVolType, calculationTimestamp, isOffsetActive, timestampWhenCalculating, usdUsdcIndex) => {
    const positionType = (0, calculationUtils_1.getInstrumentType)(position.instrument);
    const expirationTimestamp = (0, calculationUtils_1.getExpiryTimestampFromInstrumentString)(position.instrument);
    const ticker = tickers[position.instrument];
    const { r, t } = (0, calculationUtils_1.getPositionTimeToExpiryandImpliedR)(timestampWhenCalculating, calculationTimestamp, expirationTimestamp, ticker.indexPrice, ticker.markPrice);
    switch (positionType) {
        case types_1.PositionType.LinearPerpetual:
            // for USDC domain is in percent
            const domainMapped = domain.map((x) => x * ticker.indexPrice);
            return (0, futurePnlCalculator_1.getLinearFuturePnl)(domainMapped, currencyType, position, tickers[position.instrument], isOffsetActive, usdUsdcIndex);
        case types_1.PositionType.Future:
            if (position.instrument.includes("PERP")) {
                return (0, futurePnlCalculator_1.getPerpPnlOverDomain)(domain, currencyType, position, tickers[position.instrument], isOffsetActive);
            }
            else {
                return (0, futurePnlCalculator_1.getFuturePnlForDomain)(domain, currencyType, r, t, position, isOffsetActive, tickers[position.instrument].markPrice);
            }
        case types_1.PositionType.Option:
            const { strike, direction: optionType } = (0, volatilitySmile_1.getOptionInstrumentParts)(position.instrument);
            let { r: optionImpliedR, t: optionTimeToExpiry } = (0, calculationUtils_1.getPositionTimeToExpiryandImpliedR)(timestampWhenCalculating, calculationTimestamp, expirationTimestamp, ticker.indexPrice, ticker.underlyingPrice);
            return (0, optionPnlCalculator_1.getOptionPnlForDomain)(domain, currencyType, optionImpliedR, optionTimeToExpiry, position, strike, tickers, optionType, implVolType, isOffsetActive);
        default:
            console.error(`Position type does not exist for ${position.instrument}`);
            return { todayLine: [], expireLine: [] };
    }
};
exports.getPositionValuesForDomain = getPositionValuesForDomain;
// TODO: Calculate only crypto and then multiply??? This might not be possible because we multiply by crypto on some places.
const calculateFuturePnl = (currencyType, amount, averagePrice, markPrice) => {
    return currencyType === types_1.CurrencyType.CRYPTO
        ? amount / averagePrice - amount / markPrice
        : ((markPrice - averagePrice) * amount) / averagePrice;
};
exports.calculateFuturePnl = calculateFuturePnl;
const calculateOptionPnl = (currencyType, amount, averagePrice, underlyingPrice, markPrice) => {
    const pnlInCrypto = (markPrice - averagePrice) * amount;
    const pnl = currencyType === types_1.CurrencyType.CRYPTO
        ? pnlInCrypto
        : pnlInCrypto * underlyingPrice;
    return pnl;
};
exports.calculateOptionPnl = calculateOptionPnl;
